<footer class="main-footer">
    <div class="float-right d-none d-sm-block"><b>Versione</b> {{ environment.version }}</div>
    <strong
    >Copyright &copy; 2023
        <a [href]="environment?.company?.url" target="_blank">{{environment?.company?.name}}</a>.</strong
    >
    Tutti i diritti riservati.
</footer>
